import { publicClient } from "../../configs/axiosConfig";

const operatorEndpoints = {
  getPublicOperator: (slug) => `v2/operator/public/${slug}`,
};

const operatorApi = {
  getPublicOperator: async (slug) => {
    try {
      const response = await publicClient.get(
        operatorEndpoints.getPublicOperator(slug),
      );

      return { response };
    } catch (err) {
      console.error(
        "Get Public Operator Error:",
        err.response?.data || err.message,
      );

      return { err: err.response?.data || { message: err.message } };
    }
  },
};

export default operatorApi;
